import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ContactVerificationIcon, TrashIcon } from '../../../../UI/Icons/Icons';
import Button from '../../../../UI/Button/Button';
import Input from '../../../../UI/Input/Input';
import classes from './PersonalInfo.css';
import Message from '../../../../components/Message/Message';
import * as actions from '../../../../store/actions/index';
import Wrap from '../../../../hoc/Wrap/Wrap';
import Spinner from '../../../..//UI/Spinner/Spinner';
import Modal from '../../../../UI/Modal/Modal';
import MemberPopUp from './MemberPopUp.js';
import { checkValidity,EMAIL_MATCHER_REGEX, isBasicMemberAccount, isPartialRegistration, isAccountDisabled, checkSuperVisorUser, checkSuperUser, checkTier1User, decodeBase64 } from '../../../../shared/utility';
import ReactTooltip from 'react-tooltip';
import { EMAIL_VERIFICATION_ICON, HSID_BASE, LOCKED, MEMBER_ACCOUNT_MODES, PHONE_VERIFICATION_ICON, SDK_PORTAL_LIST, SECONDARY_EMAIL_VERIFICATION_ICON, SESSION_BASELINEAGENT, VERIFIED, LS_OTP_VERIFIED, LS_OTP_VERIFIED_NUMBER, SESSION_SUPERUSER, SESSION_SUPERVISORUSER, SESSION_TIER1USER } from '../../../../shared/Constants';
import { EMPTY_MESSAGE, PHONE_VERIFICATION_TOOLTIP_MESSAGE } from '../../../../shared/AdminToolMessages';


export class PersonalInfo extends Component {

    state = {
        persInfoForm: {
            userName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'userName',
                    placeholder: 'User Name',
                },
                value: this.props.member.essoData.userName,
                validation: {
                    required: false,
                    minlength: 6,
                    specialchar: ['%','<','"','+',':',';','=','\\','*','&','(',')','#', ',', '-', ' ']
                },
                disabled : this.isUserNameDisabled(this.props) || this.isAllowedforPartialRegistration(this.props),
                valid: true,
                touched: false,
                label: "User Name",
                inputType: "TwoThirdMarginLeft",
            },
            firstName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'firstName',
                    placeholder: 'first name',
                    maxLength: 41
                },
                value: this.props.member.essoData.firstName,
                validation: {
                    required: false,
                    minlength: 2,
                    maxlength: 40,
                    // specialchar: ['<','"','+',':',';','=','\\','*','&','(',')','#', ',']
                    patternRegex: /^(?!.*[\"=\\|<>%;~\\{\\}\\(\\)&\\+\\\\/#!\\?@\\$_,\\*:0123456789]).*/
                },
                disabled: this.isAllowedforPartialRegistration(this.props) || isAccountDisabled(this.props.member.essoData) || this.props.idType === HSID_BASE,
                valid: true,
                touched: false,
                label: "First Name",
                inputType: "OneThirdInlineBlock",
            },
            lastName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'lastName',
                    placeholder: 'last name',
                    maxLength: 41
                },
                value: this.props.member.essoData.lastName,
                validation: {
                    required: false,
                    minlength: 2,
                    maxlength: 40,
                    // specialchar: ['<','"','+',':',';','=','\\','*','&','(',')','#', ',']
                    patternRegex: /^(?!.*[\"=\\|<>%;~\\{\\}\\(\\)&\\+\\\\/#!\\?@\\$_,\\*:0123456789]).*/
                },
                valid: true,
                disabled: this.isAllowedforPartialRegistration(this.props) || isAccountDisabled(this.props.member.essoData) || this.props.idType === HSID_BASE,
                touched: false,
                label: "Last Name",
                inputType: "OneThirdInlineBlock",
            },
            DOB: {
                elementType: 'input',
                elementConfig: {
                    type: 'date',
                    id:'dob',
                    placeholder: 'mm/dd/yyyy',
                    min: '1900-01-01'
                },
                value: this.getPersonalInfoValuesFromProps("DOB"),
                validation: {
                    required: true,
                    restrictFuture: true,
                },
                label: "DOB",
                disabled: this.isAllowedforPartialRegistration(this.props) || isAccountDisabled(this.props.member.essoData) || this.props.idType === HSID_BASE,
                inputType: "OneThirdInlineBlock",
                valid: true,
                touched: false,
            },
            ZipCode: {
                elementType: 'label',
                elementConfig: {
                    
                },
                disabled: this.isAllowedforPartialRegistration(this.props) || isAccountDisabled(this.props.member.essoData) || this.props.idType === HSID_BASE,
                value: this.getPersonalInfoValuesFromProps("ZipCode"),
                label: "Zip Code",
                inputType: "OneThirdInlineBlock",
                valid: true,
                touched: false,
            },
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    id: 'email',
                    pattern:EMAIL_MATCHER_REGEX,
                    title: 'Format: abc.xyz@email.com'
                },
                value: (this.props.member.essoData.email?this.props.member.essoData.email.value:null),
                validation: {
                    required: false
                },
                disabled: this.isEmailDisabled(this.props) || this.isAllowedforPartialRegistration(this.props),
                valid: true,
                touched: false,
                label: "Email",
                icon: <ContactVerificationIcon iconType={EMAIL_VERIFICATION_ICON} 
                    isEmailVerified={(this.props.member.essoData.email?this.props.member.essoData.email?.verified:false)}
                    isSecondaryEmailVerified={(this.props.member.essoData.secondaryEmail?this.props.member.essoData.secondaryEmail?.verified:false)}
                    isPhoneVerified={this.props.member.essoData.phone?.verified}/>,
                inputType:!this.isAllowedforPartialRegistration(this.props)?"TwoThirdInlineBlock":"TwoThirdMarginLeft",
            },
            emailVerification: {
                valid: true,
                elementType: 'button',
                elementConfig: {
                    type: 'button',
                    id: 'email-verification'
                },
                disabled: this.isEmailVerificationDisabled(this.props) || this.isAllowedforPartialRegistration(this.props),
                label: "Verify",
            },
            secondaryEmail: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    id: 'secondaryEmail',
                    pattern: EMAIL_MATCHER_REGEX,
                    title: 'Format: abc.xyz@email.com'
                },
                value: this.props.member.essoData.secondaryEmail?.value,
                validation: {
                    required: false
                },
                disabled: this.isEmailDisabled(this.props) || this.isAllowedforPartialRegistration(this.props),
                valid: true,
                touched: false,
                label: "Secondary Email",
                icon: <ContactVerificationIcon iconType={SECONDARY_EMAIL_VERIFICATION_ICON} 
                    isEmailVerified={(this.props.member.essoData.email?this.props.member.essoData.email?.verified:false)}
                    isSecondaryEmailVerified={(this.props.member.essoData.secondaryEmail?this.props.member.essoData.secondaryEmail?.verified:false)}
                    isPhoneVerified={this.props.member.essoData.phone?.verified}/>,
                inputType: "TwoThirdInlineBlock"
            },
            deleteSecondaryEmail: {
                elementType: 'button',
                elementConfig: {
                    type: 'text',
                    id: 'deleteSecondaryEmail'
                },
                valid: true,
                value: false,
                disabled: this.isDeleteSecondaryEmailDisabled(this.props)|| this.isAllowedforPartialRegistration(this.props) || this.props.idType === HSID_BASE,
                label: "Delete secondary email"
            },
            secondaryEmailVerification: {
                valid: true,
                elementType: 'button',
                elementConfig: {
                    type: 'button',
                    id: 'secondary-email-verification'
                },
                disabled: this.isSecondaryEmailVerificationDisabled(this.props) || this.isAllowedforPartialRegistration(this.props),
                label: "Verify",
            },
            internationalCode: {
                elementType: 'inputPhoneCode',
                elementConfig: {
                    type: 'text',
                    id: 'countryCode',
                    minLength: 1,
                    maxLength: 3,
                    pattern: '[0-9]{1,3}',
                    title:'Country Code can only contain numbers'
                },
                value: this.props.member.essoData?.phone?.countryCode?this.props.member.essoData.phone.countryCode:"",
                validation: {
                    required: false,
                    minlength: 1,
                    maxlength: 3
                },
                disabled: this.props.member?.essoData?.uuid === this.getOtpVerifiedUuid() && this.getOtpVerifiedNumber().number && 
                (this.props.member?.essoData?.phone?.number!==this.getOtpVerifiedNumber().number ||
                this.props.member?.essoData?.phone?.number===this.getOtpVerifiedNumber().number && this.props.user.userType!==SESSION_SUPERUSER) ? true : 
                this.isPhoneDisabled(this.props) || this.isAllowedforPartialRegistration(this.props),
                valid: true,
                touched: false,
                label: "Country Code",
                inputType: "PhoneCode",
            },
            phone: this.props.member?.essoData?.uuid === this.getOtpVerifiedUuid() && this.getOtpVerifiedNumber().number && 
            this.props.member?.essoData?.phone?.number!==this.getOtpVerifiedNumber().number ? 
            {
                elementType: 'select',
                elementConfig: {
                    type: 'text',
                    id: 'phone',
                    placeholder: 'Select One',
                    options: [
                        { value: this.props.member?.essoData?.phone?.number, displayValue: this.props.member?.essoData?.phone?.number },
                        { value: this.getOtpVerifiedNumber().number, displayValue: this.getOtpVerifiedNumber().number }
                    ]
                },
                value: this.props.member.essoData.phone.number?this.props.member.essoData.phone.number:"",
                validation: {
                    required: false,
                },
                disabled: this.isPhoneDisabled(this.props) || this.isAllowedforPartialRegistration(this.props) ||
                (this.props.member?.essoData?.uuid === this.getOtpVerifiedUuid() && this.getOtpVerifiedNumber().number && 
                this.props.member?.essoData?.phone?.number===this.getOtpVerifiedNumber().number && this.props.user.userType!==SESSION_SUPERUSER),
                valid: true,
                touched: false,
                label: "Phone Number",
                icon: <ContactVerificationIcon iconType={PHONE_VERIFICATION_ICON} 
                    isEmailVerified={(this.props.member.essoData.email?this.props.member.essoData.email?.verified:false)}
                    isSecondaryEmailVerified={(this.props.member.essoData.secondaryEmail?this.props.member.essoData.secondaryEmail?.verified:false)}
                    isPhoneVerified={this.props.member.essoData.phone?.verified}/>,
                inputType: "phoneInput",
            } : {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'phone',
                    minLength: 7,
                    maxLength: 15,
                    pattern: '[0-9]{1,15}',
                    title:'Phone Numbers can only contain numbers'
                },
                value: this.props.member.essoData.phone.number?this.props.member.essoData.phone.number:"",
                validation: {
                    required: false,
                    minlength: 7,
                    maxlength: 15
                },
                disabled: this.isPhoneDisabled(this.props) || this.isAllowedforPartialRegistration(this.props) ||
                (this.props.member?.essoData?.uuid === this.getOtpVerifiedUuid() && this.getOtpVerifiedNumber().number && 
                this.props.member?.essoData?.phone?.number===this.getOtpVerifiedNumber().number && this.props.user?.userType!==SESSION_SUPERUSER),
                valid: true,
                touched: false,
                label: "Phone Number",
                icon: <ContactVerificationIcon iconType={PHONE_VERIFICATION_ICON} 
                    isEmailVerified={(this.props.member.essoData.email?this.props.member.essoData.email?.verified:false)}
                    isSecondaryEmailVerified={(this.props.member.essoData.secondaryEmail?this.props.member.essoData.secondaryEmail?.verified:false)}
                    isPhoneVerified={this.props.member.essoData.phone?.verified}/>,
                inputType: "phoneInput",
            },
            deletePhone: {
                elementType: 'button',
                elementConfig: {
                    type: 'text',
                    id: 'deletePhone'
                },
                valid: true,
                value: false,
                disabled: this.isDeletePhoneDisabled(this.props),
                label: "Remove Phone Number & Swap to Security Questions",
            },
            phoneVerification: {
                elementType: 'button',
                elementConfig: {
                    type: 'button',
                    id: 'phone-verification'
                },
                valid: true,
                disabled: this.isPhoneVerificationDisabled(this.props) || this.isAllowedforPartialRegistration(this.props),
                label: "Verify",
                toolTip: isAccountDisabled(this.props.member.essoData) ? EMPTY_MESSAGE : PHONE_VERIFICATION_TOOLTIP_MESSAGE
            },
            phoneType: {
                elementType: 'select',
                elementConfig: {
                    type: 'text',
                    id: 'phoneType',
                    placeholder: 'Select One',
                    options: [
                        { value: 'MOBILE', displayValue: 'Mobile' },
                        { value: 'HOME', displayValue: 'Non-Mobile' }
                    ]
                },
                value: this.props.member.essoData.phone.number?this.props.member.essoData.phone.label === 'MOBILE'?'MOBILE':'HOME':'',
                validation: {
                    required: false
                },
                disabled: this.isAllowedforPartialRegistration(this.props) || this.isPhoneTypeDisabled(this.props) || this.props.idType === HSID_BASE,
                valid: true,
                touched: false,
                label: "Phone Type",
                inputType: !this.isAllowedforPartialRegistration(this.props)?"PhoneTypeSelect":"OneThirdInlineBlock",
            }
        },
        formIsValid: false,
        message: null,
        errorMsg: null,
        httpErrMsg: null,
        popUpMessage: null,
        loading: false,
        showModal: false,
        mbrPopUpModal: null,
        formData: null,
        submitButton: null,
        portalInfoMerged: false,
        formHeader: "Email Member a Notification of Change"
    }

    phone = "phone";
    internationalCode = "internationalCode"; 
    phoneType = "phoneType";

    phoneInvalidMessages = {
        "phone": "Phone Number",
        "internationalCode": "Country Code",
        "phoneType": "Phone Type"
    };

    componentDidUpdate(prevProps, prevState){
        let phoneDisabled = this.isPhoneDisabled(this.props) || this.isAllowedforPartialRegistration(this.props) ||
        (this.props.member?.essoData?.uuid === this.getOtpVerifiedUuid() && this.getOtpVerifiedNumber().number && 
        this.props.member?.essoData?.phone?.number===this.getOtpVerifiedNumber().number && this.props.user?.userType!==SESSION_SUPERUSER);
        if (phoneDisabled !== this.state.persInfoForm.phone.disabled) {
            this.setState({persInfoForm: {...this.state.persInfoForm, 
                phone: {...this.state.persInfoForm.phone, disabled: phoneDisabled, value: prevProps.member.essoData.phone.number},
                internationalCode: {...this.state.persInfoForm.internationalCode, disabled: phoneDisabled, value: prevProps.member.essoData.phone.countryCode},
                phoneType: {...this.state.persInfoForm.phoneType, disabled: phoneDisabled, value: prevProps.member.essoData.phone.label}
            }});
        }

        let emailDisabled = this.isEmailDisabled(prevProps) ;
        if (emailDisabled !== this.state.persInfoForm.email.disabled) {
            this.setState({
                persInfoForm: {
                    ...this.state.persInfoForm,
                    email: {
                        ...this.state.persInfoForm.email,
                        disabled: emailDisabled
                    },
                    secondaryEmail: {
                        ...this.state.persInfoForm.secondaryEmail,
                        disabled: emailDisabled
                    }
                }
            });
        }

        let firstNameDisabled = this.props.user.userType===SESSION_BASELINEAGENT || this.props.idType===HSID_BASE || this.isAllowedforPartialRegistration(this.props);
        if (firstNameDisabled !== this.state.persInfoForm.firstName.disabled) {
            this.setState({persInfoForm: {...this.state.persInfoForm, firstName: {...this.state.persInfoForm.firstName, disabled: firstNameDisabled}}});
        }

        let lastNameDisabled = this.props.user.userType===SESSION_BASELINEAGENT || this.props.idType===HSID_BASE || this.isAllowedforPartialRegistration(this.props);
        if (lastNameDisabled !== this.state.persInfoForm.lastName.disabled) {
            this.setState({persInfoForm: {...this.state.persInfoForm, lastName: {...this.state.persInfoForm.lastName, disabled: lastNameDisabled}}});
        }

        let dobDisabled = this.props.user.userType===SESSION_BASELINEAGENT || this.props.idType===HSID_BASE || this.isAllowedforPartialRegistration(this.props);
        if (dobDisabled !== this.state.persInfoForm.DOB.disabled) {
            this.setState({persInfoForm: {...this.state.persInfoForm, DOB: {...this.state.persInfoForm.DOB, disabled: dobDisabled}}});
        }

        let emailVerificationDisabled = this.isEmailVerificationDisabled(prevProps);
        if (emailVerificationDisabled !== this.state.persInfoForm.emailVerification.disabled) {
            this.setState({persInfoForm: {...this.state.persInfoForm, emailVerification: {...this.state.persInfoForm.emailVerification, disabled: emailVerificationDisabled}}});
        }
        
        let phoneVerificationDisabled = this.isPhoneVerificationDisabled(prevProps);
        if (phoneVerificationDisabled !== this.state.persInfoForm.phoneVerification.disabled) {
            this.setState({persInfoForm: {...this.state.persInfoForm, phoneVerification: {...this.state.persInfoForm.phoneVerification, disabled: phoneVerificationDisabled}}});
        }

        if(!this.state.portalInfoMerged){
            let localStorageSdkList = JSON.parse(localStorage.getItem(SDK_PORTAL_LIST));
            if(this.props.portalsInfo && Object.keys(this.props.portalsInfo).length > 0 && (this.props.sdkPortalList || localStorageSdkList)){
                this.props.mergePortalInfoAdminAccount(this.props.portalsInfo, localStorageSdkList? localStorageSdkList : this.props.sdkPortalList);
                this.setState({...this.state, portalInfoMerged: true});
            }
        }
        let isDeletePhoneDisabled = this.isDeletePhoneDisabled(prevProps);
        if (isDeletePhoneDisabled !== this.state.persInfoForm.deletePhone.disabled) {
            this.setState({persInfoForm: {...this.state.persInfoForm, deletePhone: {...this.state.persInfoForm.deletePhone, disabled: isDeletePhoneDisabled}}});
        }

        let secondaryEmailVerificationDisabled = this.isSecondaryEmailVerificationDisabled(prevProps);
        if(secondaryEmailVerificationDisabled !== this.state.persInfoForm.secondaryEmailVerification.disabled){
            this.setState({persInfoForm: {...this.state.persInfoForm, secondaryEmailVerification: {...this.state.persInfoForm.secondaryEmailVerification, disabled: secondaryEmailVerificationDisabled}}})
        }

        const isUserNameDisabled = this.isUserNameDisabled(prevProps);
        if(isUserNameDisabled !== this.state.persInfoForm.userName.disabled){
            this.setState({persInfoForm: {...this.state.persInfoForm, userName :{...this.state.persInfoForm.userName, disabled: isUserNameDisabled}}});
        }

        let updatedForm = {...this.state.persInfoForm};
        let phoneTypeChange = !updatedForm['phone'].disabled && updatedForm['phone'].value && updatedForm['phoneType'].value === 'MOBILE' ? 'MOBILE' : 'NONMOBILE';
        if(this.state.formIsValid && !updatedForm['phone'].disabled && updatedForm['phone'].value && (updatedForm['phone'].value !== this.props.member.essoData.phone.number || phoneTypeChange !== this.props.member.essoData.phone.label)){
            this.props.isPhoneUpdated(true);
        }else if(this.state.formIsValid && !updatedForm['phone'].disabled && updatedForm['phone'].value && (updatedForm['phone'].value === this.props.member.essoData.phone.number &&  phoneTypeChange === this.props.member.essoData.phone.label)){
            this.props.isPhoneUpdated(false);
        }
        const uuid = this.getOtpVerifiedUuid();
        const number = this.getOtpVerifiedNumber();
        if(this.props.member.essoData.uuid === uuid && updatedForm['phone'].elementType==='input' && number.number && 
        this.props.member.essoData.phone.number!==number.number) {
            this.setState({persInfoForm: {...this.state.persInfoForm, phone :{...this.state.persInfoForm.phone, 
                elementType: 'select',
                elementConfig: {
                    type: 'text',
                    id: 'phone',
                    placeholder: 'Select One',
                    options: [
                        { value: this.props.member.essoData.phone.number, displayValue: this.props.member.essoData.phone.number },
                        { value: number.number, displayValue: number.number }
                    ]
                },
                value: this.props.member.essoData.phone.number?this.props.member.essoData.phone.number:"",
                disabled: this.isPhoneDisabled(this.props) || this.isAllowedforPartialRegistration(this.props) ||
                (this.props.member?.essoData?.uuid === this.getOtpVerifiedUuid() && this.getOtpVerifiedNumber().number && 
                this.props.member?.essoData?.phone?.number===this.getOtpVerifiedNumber().number && this.props.user.userType!==SESSION_SUPERUSER),
                validation: {
                    required: false,
                },
            },
            internationalCode: {
                ...this.state.persInfoForm.internationalCode,
                disabled: true,
            }
        }});
        } else if (this.props.member.essoData.uuid !== uuid && updatedForm['phone'].elementType==='select' || (
            this.props.member.essoData.uuid == uuid && updatedForm['phone'].elementType==='select' && number.number && 
            this.props.member.essoData.phone.number===number.number
        )) {
            this.setState({persInfoForm: {...this.state.persInfoForm, phone :{...this.state.persInfoForm.phone, 
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'phone',
                    minLength: 7,
                    maxLength: 15,
                    pattern: '[0-9]{1,15}',
                    title:'Phone Numbers can only contain numbers'
                },
                value: this.props.member.essoData.phone.number?this.props.member.essoData.phone.number:"",
                validation: {
                    required: false,
                    minlength: 7,
                    maxlength: 15
                },
                disabled: this.isPhoneDisabled(this.props) || this.isAllowedforPartialRegistration(this.props) ||
                (this.props.member?.essoData?.uuid === this.getOtpVerifiedUuid() && this.getOtpVerifiedNumber().number && 
                this.props.member?.essoData?.phone?.number===this.getOtpVerifiedNumber().number && this.props.user.userType!==SESSION_SUPERUSER),
            },
            internationalCode: {
                ...this.state.persInfoForm.internationalCode,
                disabled: this.props.member?.essoData?.uuid === this.getOtpVerifiedUuid() && this.getOtpVerifiedNumber().number && 
                (this.props.member?.essoData?.phone?.number!==this.getOtpVerifiedNumber().number ||
                this.props.member?.essoData?.phone?.number===this.getOtpVerifiedNumber().number && this.props.user.userType!==SESSION_SUPERUSER) ? true : 
                this.isPhoneDisabled(this.props) || this.isAllowedforPartialRegistration(this.props),
            }
        }});
        }
        /** 
         * Reference: https://www.npmjs.com/package/react-tooltip
         * Issue: https://github.com/wwayne/react-tooltip/issues/134
         * Now, this is useful when we are displaying some content which is dynamically injected in the UI, 
         * In case of this component we are doing so. 
         * This configuration force tooltip to rescan and attach hover event where required
         * */
        ReactTooltip.rebuild()
    }

    getOtpVerifiedUuid() {
        const uuid = decodeBase64(localStorage.getItem(LS_OTP_VERIFIED));
        return uuid
    }

    getOtpVerifiedNumber() {
        const localNumber = decodeBase64(localStorage.getItem(LS_OTP_VERIFIED_NUMBER));
        let number = {}
        try {
            number = JSON.parse(localNumber);
        } catch(e) {
            number = {}
        }
        return number
    }

    isAllowedforPartialRegistration(props) {
        return isPartialRegistration(props.idType) && (![SESSION_SUPERUSER, SESSION_SUPERVISORUSER, SESSION_TIER1USER].includes(props.user.userType))
    }

    isPhoneDisabled (props) {
        return props.member.essoData.accountStatus.aaStatus === LOCKED
        || isAccountDisabled(props.member.essoData)
            || this.isAllowedforPartialRegistration(props)
            || props.user.userType===SESSION_BASELINEAGENT
            || props.idType===HSID_BASE;
            // || (props.member.essoData.accountStatus.aaStatus === VERIFIED
            //         && (props.member.essoData.credential 
            //             // && !props.member.essoData.credential.securityQuestionAndAnswers 
            //             && !props.member.essoData.phone.number)) ? true : false
    }
    isEmailDisabled(props) {
        /**
         * If Super User it should never be disabled
         * if esso account aaStatus is locked then disabled
         * If esso account aaStatus is verified but securityQA and phone is not defined then disabled
         */
        return (checkSuperUser(props.user.userType) || checkTier1User(props.user.userType) || checkSuperVisorUser(props.user.userType) ? 
        props.member.essoData.accountStatus.aaStatus === LOCKED || this.isAllowedforPartialRegistration(props) : 
        props.member.essoData.accountStatus.aaStatus === LOCKED || 
        (props.member.essoData.accountStatus.aaStatus === VERIFIED && 
        (props.member.essoData.credential && 
            !props.member.essoData.credential.securityQuestionAndAnswers && 
            !props.member.essoData.phone.number)))
        || isAccountDisabled(props.member.essoData)
        || props.user.userType===SESSION_BASELINEAGENT
        || props.idType===HSID_BASE;
    } 
    isEmailVerificationDisabled(props) {
        /**
             * if email is empty then its disabled
             * if email is verified then its disabled
             * if essoStatus enableDisableStatus is disabled then its disabled
         */
        return !props.member.essoData.email || 
        (props.member.essoData.email&&props.member.essoData.email.verified) || 
        isAccountDisabled(props.member.essoData)
        || props.user.userType===SESSION_BASELINEAGENT
        || props.idType===HSID_BASE;
    } 
    
    isUnameVerificationDisabled(props) {
        return isAccountDisabled(props.member.essoData)
    } 
    isSecondaryEmailVerificationDisabled(props) {
        return !this.props.member.essoData.secondaryEmail 
        || (this.props.member.essoData.secondaryEmail && this.props.member.essoData.secondaryEmail.verified) 
        || isAccountDisabled(this.props.member.essoData)
        || props.user.userType===SESSION_BASELINEAGENT
        || props.idType===HSID_BASE
    }

    isDeleteSecondaryEmailDisabled(props) {
        return this.isEmailDisabled(this.props)
    }

    isPhoneVerificationDisabled(props,) {
        /**
             * if phone number is empty then its disabled
             * if phone number is verified then its disabled
             * if essoStatus enableDisableStatus is disabled then its disabled
         */
        return !this.props.member.essoData.phone.number 
        // return (!this.state?.persInfoForm['internationalCode'].value || !this.state?.persInfoForm['phone'].value)
        || (this.props.member.essoData.phone.number && this.props.member.essoData.phone.verified) 
        || isAccountDisabled(this.props.member.essoData)
        || props.user.userType===SESSION_BASELINEAGENT
        || props.idType===HSID_BASE
    }

    isUserNameDisabled(props) {
        return (checkSuperUser(props.user.userType) || checkTier1User(props.user.userType) || checkSuperVisorUser(props.user.userType) ? 
        props.member.essoData.accountStatus.aaStatus === LOCKED || this.isAllowedforPartialRegistration(props) : 
        props.member.essoData.accountStatus.aaStatus === LOCKED || (props.member.essoData.accountStatus.aaStatus === VERIFIED 
        && (props.member.essoData.credential && !props.member.essoData.credential.securityQuestionAndAnswers && !props.member.essoData.phone.number))) ||
        isAccountDisabled(props.member.essoData)
        || props.user.userType===SESSION_BASELINEAGENT
        || props.idType===HSID_BASE;
    }

    isDeletePhoneDisabled(props) {
        return props.member.essoData.accountStatus.aaStatus === LOCKED 
        || !props.member.essoData.phone.number
        || this.isAllowedforPartialRegistration(props)
        || isAccountDisabled(props.member.essoData)
        || props.user.userType===SESSION_BASELINEAGENT
        || props.idType === HSID_BASE
    }

    isPhoneTypeDisabled(props){
        return props.member.essoData.accountStatus.aaStatus === LOCKED ||
        isAccountDisabled(props.member.essoData) 
        // ||
        // (props.member.essoData.accountStatus.aaStatus === VERIFIED && 
        // (props.member.essoData.credential && 
        //     // !props.member.essoData.credential.securityQuestionAndAnswers && 
        //     !props.member.essoData.phone.number))
        // ? true : false
    }

    componentDidMount() {
        if(!this.props.portalsList || !this.props.portalsList.length > 0) {
            this.props.fetchPortals(this.props.sdkPortalList);
        }
        this.props.setDisplayMessage(null);
    }

    inputChangedHandler =(event, inputIdentifier) => {

        let updatedForm = {...this.state.persInfoForm};

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = event.target.value;
        if(event.target.value) {
            if(updatedFormElement.validation != null) {
                const validation = checkValidity(updatedFormElement.value, updatedFormElement.validation);
                updatedFormElement.valid =  validation.isValid;
                if(validation.isValid) { this.props.setDisplayMessage(null); }
                else if (validation.message) { 
                    if(updatedFormElement.elementConfig.id === 'userName'){
                        validation.message = "Invalid New Username Format.";
                    }
                    this.props.setDisplayMessage({type: "Error", info: {message:validation.message}}); 
                }
            }
        } else if(updatedFormElement.elementConfig.id === 'userName' && updatedFormElement.value === ''){
            this.props.setDisplayMessage({type: "Error", info: {message:"New Username is Required."}});
        }else  { //if (updatedForm[inputIdentifier].validation) {
            updatedFormElement.valid = false;
            this.props.setDisplayMessage(null);
        }

        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
        }
        if(inputIdentifier === 'phone' && formIsValid){
            let phoneTypeChange = !updatedForm['phone'].disabled && updatedForm['phone'].value && updatedForm['phoneType'].value === 'MOBILE' ? 'MOBILE' : 'NONMOBILE';
            if(!updatedForm['phone'].disabled && updatedForm['phone'].value && (updatedForm['phone'].value !== this.props.member.essoData.phone.number || phoneTypeChange !== this.props.member.essoData.phone.label)){
                this.props.isPhoneUpdated(true);
            }else if(!updatedForm['phone'].disabled && updatedForm['phone'].value && (updatedForm['phone'].value === this.props.member.essoData.phone.number &&  phoneTypeChange === this.props.member.essoData.phone.label)){
                this.props.isPhoneUpdated(false);
            }
            if(this.props.member?.essoData?.uuid === this.getOtpVerifiedUuid() && this.getOtpVerifiedNumber().number && 
            this.props.member?.essoData?.phone?.number!==this.getOtpVerifiedNumber().number) {
                updatedForm['internationalCode'].value = event.target.value === this.getOtpVerifiedNumber().number ? this.getOtpVerifiedNumber().countryCode :
                this.props.member.essoData?.phone?.countryCode
            }
        }
        this.setState({persInfoForm: updatedForm, formIsValid: formIsValid});
    }

    personalInfoHandler = (event) => {
        event.preventDefault();
        if(this.props.disableTab === "-1") {
            return;
        }
        const invalidFields = this.validateForm();
        if(invalidFields === 0){
            let formData = this.getFormData();
            if(formData) {

                if(formData.phoneNumber || formData.emailOld || formData.isUserNameUpdated || (!formData.emailOld && formData.email) || formData.secondaryEmail){
                
                    // Model popup will be opened and member account should be called
                    this.setState({formData: formData, showModal: true, submitButton: "PersInfo"});
                } else if(formData.nameUpdated || formData.dob || formData.zipCode){
                    // Call API to update the name
                    this.props.modifyAccount(formData);
                }
            }
        }
    }

    getFormData = () => {
        let dataChanged = false;
        let formData = {
            "userName": this.state.persInfoForm['userName'].value,
            "isUserNameUpdated": false,
            "email": "",
            "emailOld": "",
            "secondaryEmail": "",
            "secondaryEmailOld": "",
            "firstName": this.state.persInfoForm['firstName'].value,
            "lastName": this.state.persInfoForm['lastName'].value,
            "nameUpdated": false,
            "phoneExists": false,
            "phoneNumber": "",
            "phoneType": "",
            "selectLangPortal": "",
            "targetPortal": "",
            "uuid": this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid,
            "oldUserName": "",
            "firstNameOld": "",
            "lastNameOld": "",
            "phoneNumberOld": "",
            "oldCountryCode": ""
        }

        if(this.state.persInfoForm['firstName'].value !== this.props.member.essoData.firstName){
            formData.nameUpdated = true;
            dataChanged = true;
            formData.firstNameOld = this.props.member.essoData.firstName;
        }

        if(this.state.persInfoForm['lastName'].value !== this.props.member.essoData.lastName){
            formData.nameUpdated = true;
            dataChanged = true;
            formData.lastNameOld = this.props.member.essoData.lastName;
        }

        if(this.state.persInfoForm['DOB'].value !== this.getPersonalInfoValuesFromProps('DOB')){
            formData.dob = this.state.persInfoForm['DOB'].value;
            formData.dobOld = this.getPersonalInfoValuesFromProps('DOB')
            dataChanged = true;
        }

        if(this.state.persInfoForm['ZipCode'].value !== this.getPersonalInfoValuesFromProps('ZipCode')){
            formData.zipCode = this.state.persInfoForm['ZipCode'].value;
            formData.zipCodeOld = this.getPersonalInfoValuesFromProps('ZipCode')
            dataChanged = true;
        }
        
        if(this.state.persInfoForm['userName'].value !== this.props.member.essoData.userName){
            formData.isUserNameUpdated = true;
            formData.email = this.props.member.essoData.email?.value;
            formData.oldUserName = this.props.member.essoData?.userName;
            dataChanged = true;
        }

        if((this.state.persInfoForm['email'].value?.toLowerCase() !== this.props.member.essoData.email?.value.toLowerCase())){
            formData.email = this.state.persInfoForm['email'].value?.toLowerCase();
            formData.emailOld = this.props.member.essoData.email?.value.toLowerCase();
            dataChanged = true;
        }

        if((this.isSecondaryEmailInputFieldUpdated())){
            formData.email = this.state.persInfoForm['email'].value.toLowerCase();
            formData.secondaryEmail = this.state.persInfoForm['secondaryEmail'].value.toLowerCase();
            formData.secondaryEmailOld = this.props.member.essoData.secondaryEmail?.value.toLowerCase();
            dataChanged = true;
        }

        if(this.isPhoneFieldUpdated()){
            formData.phoneExists = this.props.member.essoData.phone.number ? true : false;
            formData.email = this.state.persInfoForm['email'].value;
            formData.phoneNumber = this.state.persInfoForm['phone'].value;
            formData.oldPhoneType = this.props.member.essoData.phone.label;
            formData.phoneType = this.state.persInfoForm['phoneType'].value === 'MOBILE' ? 'MOBILE' : 'HOME';
            formData.phoneNumberOld = this.props.member.essoData.phone.number
            formData.countryCode = this.state.persInfoForm['internationalCode'].value;
            formData.oldCountryCode = this.props.member.essoData.phone.countryCode;
            dataChanged = true;
        }
        return dataChanged?formData:null;
    }

    checkInvalidsInPhone (field1, field2, invalidFields) {
        if (!this.state.persInfoForm[field1].value 
            && !invalidFields.includes(this.phoneInvalidMessages[field1])) {
            invalidFields.push(this.phoneInvalidMessages[field1])
        }
        if (!this.state.persInfoForm[field2].value 
            && !invalidFields.includes(this.phoneInvalidMessages[field2])) {
            invalidFields.push(this.phoneInvalidMessages[field2])
        }
    }

    validateForm () {
        const excludedFields = ["phoneVerification", "emailVerification", "phone", "phoneType", "deletePhone","secondaryEmailVerification", "deleteSecondaryEmail", "ZipCode", "internationalCode"]
        if(isBasicMemberAccount(this.props.idType)){
            excludedFields.push(...MEMBER_ACCOUNT_MODES.BASE_ACCOUNT_MODE);
        }
        let invalidFields =[];
        for( let key in this.state.persInfoForm) {
            if(excludedFields.indexOf(key) === -1 && !this.state.persInfoForm[key].value && !this.state.persInfoForm[key].disabled) {
                const fieldName = this.state.persInfoForm[key].label;
                if(fieldName === "Secondary Email" && !this.props.member.essoData.secondaryEmail){
                    continue;
                }
                invalidFields.push(fieldName);
            }

            if(key === this.phone || key === this.internationalCode || key === this.phoneType
                && !this.state.persInfoForm[this.phone].disabled ){

                if (key === this.phone && this.state.persInfoForm[this.phone].value 
                    && this.state.persInfoForm[this.phone].value !== this.props.member.essoData.phone.number) {
                    this.checkInvalidsInPhone(this.internationalCode, this.phoneType, invalidFields)
                }
                else if (key === this.internationalCode && this.state.persInfoForm[this.internationalCode].value 
                    && this.state.persInfoForm[this.internationalCode].value !== this.props.member.essoData.phone.countryCode) {
                    this.checkInvalidsInPhone(this.phone, this.phoneType, invalidFields)
                }
                else if (key === this.phoneType && this.state.persInfoForm[this.phoneType].value && 
                this.state.persInfoForm[this.phoneType].value !== this.props.member.essoData.phone.label) {
                    this.checkInvalidsInPhone(this.internationalCode, this.phone, invalidFields)
                }
            }
        }

        let updateBlankEmailFirst = !this.props.member.essoData.email && (this.isSecondaryEmailInputFieldUpdated() || this.isPhoneFieldUpdated()) ? true : false;
        let displayText = null;
        if(updateBlankEmailFirst){
            invalidFields.push("Blank Email");
            displayText = "Please Update Blank Email First";
        }else{
            displayText = invalidFields.length>0?invalidFields.length===1?invalidFields.join(" ").concat(" field is required"):invalidFields.join(", ").concat(" fields are required"): null;
        }
        
        this.props.setDisplayMessage({type: "Error", info: {message:displayText}});

        return invalidFields.length;
    }

    isSecondaryEmailInputFieldUpdated(){
        return this.state.persInfoForm['secondaryEmail'].value?.toLowerCase() !== this.props.member.essoData.secondaryEmail?.value.toLowerCase();
    }

    isPhoneFieldUpdated(){
        let countryCode = this.state.persInfoForm['internationalCode'].value;
        let phoneTypeChange = !this.state.persInfoForm['phone'].disabled && this.state.persInfoForm['phone'].value && this.state.persInfoForm['phoneType'].value === 'MOBILE' ? 'MOBILE' : 'NONMOBILE';
        return !this.state.persInfoForm['phone'].disabled && this.state.persInfoForm['phone'].value && (this.state.persInfoForm['phone'].value !== this.props.member.essoData.phone.number || phoneTypeChange !== this.props.member.essoData.phone.label || countryCode !== this.props.member.essoData?.phone?.countryCode)
    }

    getPersonalInfoValuesFromProps(element) {
        let value = "";
        if (element === "DOB") {
            value = this.props.member.essoData.dob ? this.props.member.essoData.dob : "";
        }
        else if (element === "ZipCode") {
            value = this.props.member.mdmZip ? this.props.member.mdmZip : "";
        }
        return value
    }

    resetAccount = (event) =>{
        //console.log("[ModifyAccount] resetFormData");
        event.preventDefault();
        if(this.props.disableTab === "-1") {
            return;
        }
        this.props.setDisplayMessage(null);
        // if(this.state.formIsValid){
            let updatedForm = this.state.persInfoForm;
            updatedForm['userName'].value = this.props.member.essoData.userName;
            updatedForm['userName'].valid = true;
            updatedForm['firstName'].value = this.props.member.essoData.firstName;
            updatedForm['firstName'].valid = true;
            updatedForm['lastName'].value = this.props.member.essoData.lastName;
            updatedForm['lastName'].valid = true;
            updatedForm['DOB'].value = this.getPersonalInfoValuesFromProps("DOB");
            updatedForm['DOB'].valid = true;
            updatedForm['ZipCode'].value = this.getPersonalInfoValuesFromProps("ZipCode");
            updatedForm['ZipCode'].valid = true;
            updatedForm['email'].value = this.props.member.essoData.email?.value;
            updatedForm['email'].valid = true;
            updatedForm['secondaryEmail'].value = this.props.member.essoData.secondaryEmail?.value;
            updatedForm['secondaryEmail'].valid = true;
            if(!this.state.persInfoForm['phone'].disabled) {
                updatedForm['phone'].value = this.props.member.essoData.phone.number?this.props.member.essoData.phone.number:"";
                updatedForm['phone'].valid = true;
                updatedForm['phoneType'].value = this.props.member.essoData.phone.number?this.props.member.essoData.phone.label === 'MOBILE'?'MOBILE':'HOME':'';
                updatedForm['phoneType'].valid = true;
                updatedForm['internationalCode'].value = this.props.member.essoData?.phone?.countryCode?this.props.member.essoData.phone.countryCode:"";
                updatedForm['internationalCode'].valid = true;
            }
            this.props.isPhoneUpdated(false);
            this.setState({persInfoForm: updatedForm, formIsValid: false});
        // }
    }

    resetToPersonalInfo = (event) =>{
        //console.log("[MemberPopUp] resetPage");
        this.setState({showModal: false});
    }

    toggleModalHandler = () => {
        this.setState({showModal: !this.state.showModal, deletePhoneDisclaimer: false, formHeader: "Email Member a Notification of Change"});
    }

    verifyEmail = () => {
        if(this.props.disableTab === "-1") {
            return;
        }
        let formData = {
            email: this.props.member.essoData.email.value,
            phoneNumber: "",
            uuid: this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid,
            userName: this.props.member.essoData.userName
        }
        this.setState({formData: formData, showModal: true, submitButton: "verifyEmail", formHeader: "Email Member a Notification of Change"});
    }
    verifySecondaryEmail = () => {
        if(this.props.disableTab === "-1") {
            return;
        }
        let formData = {
            email: this.props.member.essoData.email?.value,
            secondaryEmail: this.props.member.essoData.secondaryEmail.value,
            phoneNumber: "",
            uuid: this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid,
            userName: this.props.member.essoData.userName
        }
        this.setState({formData: formData, showModal: true, submitButton: "verifyEmail", formHeader: "Email Member a Notification of Change"});
    }
    verifyPhone = () => {
        if(this.props.disableTab === "-1") {
            return;
        }
        let isBlankEmail = !this.props.member.essoData.email ? true : false; 
        let formData = {
            email: this.props.member.essoData.email?.value,
            phoneNumber: this.props.member.essoData?.phone?.number || this.state?.persInfoForm['phone'].value,
            countryCode: this.props.member.essoData?.phone?.countryCode || this.state?.persInfoForm['internationalCode'].value,
            uuid: this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid,
            userName: this.props.member.essoData.userName
        }
        this.setState({formData: formData, showModal: isBlankEmail ? false : true, submitButton: "verifyPhone", formHeader: "Email Member a Notification of Change"});
    }

    updateUsername = () => {
        let formData = {
            email: this.props.member.essoData.email.value,
            userName: this.props.member.essoData.userName.value,
            uuid: this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid
        }
        this.setState({formData: formData, showModal: true, submitButton: "updateUsername", formHeader: "Email Member a Notification of Change"});
    }

    deletePhone = () => {

        let isEmailVerified = this.props.member.essoData.email?.verified;

        if(!isEmailVerified){
            let displayText = "The member's email address must be verified before the phone number can be deleted.";
            this.props.setDisplayMessage({type: "Error", info: {message:displayText}});
            return false;
        }

        let formData = {
            email : this.props.member.essoData.email.value,
            uuid : this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid,
            phoneAvailable : this.props.member.essoData.phone.number ? true : false,
            securityQues : this.props.member.essoData.credential && this.props.member.essoData.credential.securityQuestionAndAnswers ? true : false,
            accStatus : this.props.member.essoData.accountStatus.aaStatus,
            headless: this.props.isHeadlessUser,
            phoneNumber: this.props.member.essoData.phone.number,
            phoneType: this.props.member.essoData.phone.label,
            userName : this.props.member.essoData.userName
        }
        this.setState({
            formData: formData, 
            showModal: true, 
            submitButton: "deletePhone", 
            formHeader: "Delete Phone Number & Send Email Notification of Change",
            deletePhoneDisclaimer: true
        });
    }
    
    deleteSecondaryEmail = () => {

        let isEmailVerified = this.props.member.essoData.email.verified;

        if(!isEmailVerified){
            let displayText = "The member's email address must be verified before the secondary email can be deleted.";
            this.props.setDisplayMessage({type: "Error", info: {message:displayText}});
            return false;
        }

        let formData = {
            deleteSecondaryEmail:true,
            secondaryEmail: this.props.member.essoData.secondaryEmail?.value,
            userName: this.props.member.essoData.userName,
            uuid: this.props.member.essoData.uuid
        }

        this.setState({
            formData: formData,
            showModal: true, 
            submitButton: "deleteSecondaryEmail", 
            formHeader: "Delete Secondary Email",
        });

    }

    getVerifyStatusIcon = (key) => {
        return <ContactVerificationIcon 
                    iconType={key === "email" ? EMAIL_VERIFICATION_ICON : key === "secondaryEmail" ? SECONDARY_EMAIL_VERIFICATION_ICON : PHONE_VERIFICATION_ICON} 
                    isEmailVerified={this.props.member.essoData.email?this.props.member.essoData.email.verified:false}
                    isSecondaryEmailVerified={this.props.member.essoData.secondaryEmail?this.props.member.essoData.secondaryEmail.verified:false} 
                    isPhoneVerified={this.props.member.essoData.phone.number === this.state.persInfoForm.phone.value && 
                        this.state.persInfoForm.phone.value  ? this.props.member.essoData.phone.verified :false}
                />
    }

    filterPhoneType = (element) => {
        if(this.isAllowedforPartialRegistration(this.props) && element.id === 'phoneType') {
            return false;
        }
        else {
            return true;
        }
    }

    userSuccessMessage(successMessage) {
        return successMessage!==null? <div className={classes.RowMessage}><Message msgType={this.props.message.type} info={this.props.message.info} /></div>: null;
    }

    userErrorMessage(errorMessage) {
        return errorMessage!==null? <div className={classes.RowMessage}><Message msgType={this.props.errorMsg.type} info={this.props.errorMsg.info} /></div>: null;
    }

    toggleUserMessageForSupervisor(isSupervisor, isOTPVerified, position){
        return position==='top' ?  (isSupervisor) || (!isSupervisor && true) : false
    }

    render() {
        const formsElementsArrayCommon = [];
        const formsElementsArraySpl = [];
        const memberAccountViewMode = isBasicMemberAccount(this.props.idType) ? MEMBER_ACCOUNT_MODES.BASE_ACCOUNT_MODE : MEMBER_ACCOUNT_MODES.DEFAULT_MODE
        for(let key in this.state.persInfoForm) {
            if(!memberAccountViewMode.includes(key) && ! MEMBER_ACCOUNT_MODES.REMAINING_FIELDS.includes(key)){
                formsElementsArrayCommon.push({
                    id: key,
                    config: this.state.persInfoForm[key],
                    icon: (key === 'email' || key === 'secondaryEmail' || 
                        (key === 'phone'  && this.props.member.essoData.phone && this.props.member.essoData.phone.number && this.props.member.essoData.phone.number.length > 0)) ? this.getVerifyStatusIcon(key): null
                });
            }
        }
        for(let key in this.state.persInfoForm) {
            if(MEMBER_ACCOUNT_MODES.REMAINING_FIELDS.includes(key)){
                formsElementsArraySpl.push({
                    id: key,
                    config: this.state.persInfoForm[key],
                    icon: (key === 'email' || key === 'secondaryEmail' || 
                        (key === 'phone'  && this.props.member.essoData.phone && this.props.member.essoData.phone.number && this.props.member.essoData.phone.number.length > 0)) ? this.getVerifyStatusIcon(key): null
                });
            }
        }

        let enableDisableLayerClass = checkSuperVisorUser(this.props.user.userType) && this.props.idType !== HSID_BASE
         && this.props.isOTPVerified ? classes.EnableEmailPhone : null;
        let enableDisableLayerClassButtons = checkSuperVisorUser(this.props.user.userType) && this.props.idType !== HSID_BASE 
        && this.props.isOTPVerified? classes.EnableEmailPhoneButtons : null;
        let buttons = (
            <div style={{display:"flex", justifyContent: "center", margin: "10px 60px 10px 5px"}} className={enableDisableLayerClassButtons}>
                <Button id="cancel" btnType="Cancel" clicked={this.resetAccount} disabled={isAccountDisabled(this.props.member.essoData)}>Cancel</Button>    
                <Button id="save" btnType="Search" disabled={(!this.state.formIsValid || isAccountDisabled(this.props.member.essoData)) || !this.state.persInfoForm['email']}>Complete/Send Notification</Button>
            </div>
        );
        let essoForm = (
            <form onSubmit={this.personalInfoHandler}>
                <div>
                    {formsElementsArrayCommon
                    .filter(this.filterPhoneType)
                    .map(formElement => {
                        let element;
                        if (formElement.config.elementType !== "button") {
                            element =  <Input
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={formElement.config.value}
                                invalid={!formElement.config.valid}
                                shouldValidate={formElement.config.validation}
                                touched={formElement.config.touched}
                                disabled={formElement.config.disabled}
                                label={formElement.config.label}
                                icon={formElement.icon}
                                changed={(event) => this.inputChangedHandler(event, formElement.id)}
                                extendedInput={formElement.config.extendedInput}
                                inputType={formElement.config.inputType}
                                tabIndex={this.props.disableTab}
                            />
                            if(!this.props.member.essoData.secondaryEmail && formElement.id === 'secondaryEmail'){
                                element = null;
                            }
                        } 
                        else if( formElement.id === 'deletePhone' && formElement.config.disabled === false) {
                            element = <div key={formElement.id} className={classes.DeleteIcon}>
                                    <TrashIcon fontSize="20px" clicked={this.deletePhone} toolTip={formElement.config.label}/>
                                </div>
                        } else if(formElement.id === 'deleteSecondaryEmail' && formElement.config.disabled === false && this.props.member.essoData.secondaryEmail){
                            element = <div key={formElement.id} className={classes.DeleteIcon}>
                                    <TrashIcon fontSize="20px" clicked={this.deleteSecondaryEmail} toolTip={formElement.config.label}/>
                                </div>
                        } else if( formElement.id === "emailVerification" && !this.isAllowedforPartialRegistration(this.props)){
                            element = <div key={formElement.id} className={classes.VerifyButton}>
                                <Button btnType="ResetVerify" clicked={this.verifyEmail} disabled={formElement.config.disabled}>{formElement.config.label}</Button>
                            </div>
                        } else if( formElement.id === "secondaryEmailVerification" && !this.isAllowedforPartialRegistration(this.props)){
                            element = this.props.member.essoData.secondaryEmail  ? <div key={formElement.id} className={classes.VerifyButton}>
                                <Button btnType="ResetVerify" clicked={this.verifySecondaryEmail} disabled={formElement.config.disabled}>{formElement.config.label}</Button>
                            </div> : null;
                        } else if( formElement.id === "phoneVerification" && !this.isAllowedforPartialRegistration(this.props)){
                            let child =  this.props.member.essoData.phone.number !== 
                            this.state.persInfoForm.phone.value && this.state.persInfoForm.phone.value ? formElement.config.label :  (formElement.config.disabled && (this.state.persInfoForm.phone.value==="") ?
                            <span data-tip={formElement.config.toolTip}>{formElement.config.label}</span>:formElement.config.label);
                            element = <div key={formElement.id} className={classes.VerifyButton} >
                                <Button btnType="ResetVerify" clicked={this.verifyPhone} disabled={this.props.member.essoData.phone.number !== 
                                    this.state.persInfoForm.phone.value && this.state.persInfoForm.phone.value ? false: formElement.config.disabled}>{child}</Button>
                            </div>
                        }
                        return element;
                })}
                </div>
                <div className={enableDisableLayerClass}>
                {this.toggleUserMessageForSupervisor(checkSuperVisorUser(this.props.user.userType), this.props.isOTPVerified) && this.userSuccessMessage(this.props.message, this.props.isOTPVerified)}
                {this.toggleUserMessageForSupervisor(checkSuperVisorUser(this.props.user.userType), this.props.isOTPVerified) && this.userErrorMessage(this.props.errorMsg, this.props.isOTPVerified)}
                {formsElementsArraySpl
                    .filter(this.filterPhoneType)
                    .map(formElement => {
                        let element;
                        if (formElement.config.elementType !== "button") {
                            element =  <Input
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={formElement.config.value}
                                invalid={!formElement.config.valid}
                                shouldValidate={formElement.config.validation}
                                touched={formElement.config.touched}
                                disabled={formElement.config.disabled}
                                label={formElement.config.label}
                                icon={formElement.icon}
                                changed={(event) => this.inputChangedHandler(event, formElement.id)}
                                extendedInput={formElement.config.extendedInput}
                                inputType={formElement.config.inputType}
                                tabIndex={this.props.disableTab}
                            />
                            if(!this.props.member.essoData.secondaryEmail && formElement.id === 'secondaryEmail'){
                                element = null;
                            }
                        } 
                        else if(formElement.id === 'deleteSecondaryEmail' && formElement.config.disabled === false && this.props.member.essoData.secondaryEmail){
                            element = <div key={formElement.id} className={classes.DeleteIcon}>
                                    <TrashIcon fontSize="20px" clicked={this.deleteSecondaryEmail} toolTip={formElement.config.label}/>
                                </div>
                        } else if( formElement.id === "emailVerification" && !this.isAllowedforPartialRegistration(this.props)){
                            element = <div key={formElement.id} className={classes.VerifyButton}>
                                <Button btnType="ResetVerify" clicked={this.verifyEmail} disabled={formElement.config.disabled}>{formElement.config.label}</Button>
                            </div>
                        } else if( formElement.id === "secondaryEmailVerification" && !this.isAllowedforPartialRegistration(this.props)){
                            element = this.props.member.essoData.secondaryEmail  ? <div key={formElement.id} className={classes.VerifyButton}>
                                <Button btnType="ResetVerify" clicked={this.verifySecondaryEmail} disabled={formElement.config.disabled}>{formElement.config.label}</Button>
                            </div> : null;
                        } else if( formElement.id === "phoneVerification" && !this.isAllowedforPartialRegistration(this.props)){
                            let child =  this.props.member.essoData.phone.number !== 
                            this.state.persInfoForm.phone.value && this.state.persInfoForm.phone.value ? formElement.config.label :  (
                                formElement.config.disabled && (this.state.persInfoForm.phone.value==="") ?
                                <span data-tip={formElement.config.toolTip}>{formElement.config.label}</span>:formElement.config.label );
                            element = <div key={formElement.id} className={classes.VerifyButton} >
                                <Button btnType="ResetVerify" clicked={this.verifyPhone} disabled={this.props.member.essoData.phone.number !== 
                                    this.state.persInfoForm.phone.value && this.state.persInfoForm.phone.value ? false: formElement.config.disabled}>{child}</Button>
                            </div>
                        }
                        return element;
                })}
                </div>
                {!this.isAllowedforPartialRegistration(this.props) && buttons}
            </form>
        );


        const modalWindowEmpty = !this.state.showModal && this.props.processing?(
            <Modal show={this.props.processing}>
                <Spinner/>
            </Modal>
        ):null;

        const mbrPopUpModal = this.state.showModal?(
            <Modal show={this.state.showModal} modalClosed={this.toggleModalHandler}>
                {this.props.processing?<Spinner/>:
                <MemberPopUp
                    formData={this.state.formData}
                    portalsList = {this.props.portalsList}
                    portalsInfo = {this.props.portalsInfo}
                    setMemPopUpDisplayMessage = {this.props.setMemPopUpDisplayMessage}
                    popUpMessage = {this.props.popUpMessage}
                    resetToPersonalInfo = {this.props.resetToPersonalInfo}
                    modalSpinnerStart = {this.props.modalSpinnerStart}
                    modifyAccount = {this.props.modifyAccount}
                    modifyAccountStart = {this.props.modifyAccountStart}
                    closeModal = {this.toggleModalHandler}
                    verifyEmailorPhone = {this.props.verifyEmailorPhone}
                    updateUsername = {this.props.updateUsername}
                    deletePhone={this.props.deletePhone}
                    deleteSecondaryEmail={this.props.deleteSecondaryEmail}
                    submitButton = {this.state.submitButton}
                    formHeader = {this.state.formHeader}
                    agentUserType = {this.props.user.userType}
                    idType = {this.props.idType}
                    disabledPortals = {this.props.disabledPortals}
                >
                {this.state.deletePhoneDisclaimer === true && <div className={classes.FormDisclaimer}>Removing the phone number will <b>SWAP THE MEMBERS RECOVERY OPTIONS</b> &amp; force them to set up Security Questions &amp; Create a New Password upon next login</div>}
                </MemberPopUp>}
            </Modal>
        ):null;

        let personalInfoPage = (
            <Wrap>
                {/* <div className={classes.Row}>
                    <label className={classes.RowLabel}>User Name</label>
                    <div className={classes.Bottom}>{this.props.member.essoData.userName}</div>
                </div>
                <div className={classes.Row}>
                    <label className={classes.RowLabel}>UUID</label>
                    <div className={classes.Bottom}>{this.props.member.healthSafeId?this.props.member.healthSafeId:this.props.member.essoData.uuid}</div>
                </div> */}
                {essoForm}
            </Wrap>
        );

        return (
            <div>
                <div className={classes.FormTitle}>HealthSafe ID Registered Information</div>
                <p className={classes.Message}>{this.props.formMessage}</p>
                <ReactTooltip />
                {modalWindowEmpty}
                {mbrPopUpModal}
                {this.toggleUserMessageForSupervisor(checkSuperVisorUser(this.props.user.userType), this.props.isOTPVerified, 'top') && this.userSuccessMessage(this.props.message, this.props.isOTPVerified)}
                {this.toggleUserMessageForSupervisor(checkSuperVisorUser(this.props.user.userType), this.props.isOTPVerified, 'top') && this.userErrorMessage(this.props.errorMsg, this.props.isOTPVerified)}
                {personalInfoPage}
            </div>
        );
    }
}

export const mapStateToProps = state => {
    return {
        member: state.member.member,
        message: state.member.persInfoMsg,
        processing: state.personalInfo.processing,
        errorMsg: state.personalInfo.message,
        popUpMessage: state.personalInfo.popUpMessage,
        loading: state.personalInfo.modifyDetails,
        portalsList: state.personalInfo.portals,
        portalsInfo: state.personalInfo.portalsInfo,
        portalsLoading: state.personalInfo.portalsLoading,
        portalInfoLoading: state.personalInfo.portalInfoLoading,
        selectedLangInfo: state.personalInfo.selectedLangInfo,
        showModal: state.personalInfo.showModal,
        user: state.usr.user,
        sdkPortalList: state.member.sdkPortalList,
        disabledPortals: state.addEligibility.disabledPortals
    }
}

export const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        modifyAccountStart: () => dispatch(actions.modifyAccountStart()),
        modifyAccount: (memberInfo) => dispatch(actions.modifyAccountDetails(memberInfo, ownProps.idType)),
        setDisplayMessage: (message) => dispatch(actions.setPersInfoDisplayMessage(message)),
        setMemPopUpDisplayMessage: (message) => dispatch(actions.setMemPopUpDisplayMessage(message)),
        fetchPortals: (sdkPortalList) => dispatch(actions.fetchMemberAccountPortals(sdkPortalList)),
        modalSpinnerStart: () => dispatch(actions.modalSpinnerStart()),
        verifyEmailorPhone: (userData) => dispatch(actions.verifyEmailorPhone(userData)),
        mergePortalInfoAdminAccount: (portalsInfo, sdkPortalList) => dispatch(actions.mergePortalInfoAdminAccount(portalsInfo, sdkPortalList)),
        deletePhone: (userData) => dispatch(actions.deletePhone(userData)),
        deleteSecondaryEmail: (userData) => dispatch(actions.deleteSecondaryEmail(userData))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);
